function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgDocPdf(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 16 16",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M13.25 4.322h-3.117V1.001zm-3.503.412V1.001L2.742 1v6.534H13.25v-2.8zm-4.937 5.65a.686.686 0 00-.259-.097 1.822 1.822 0 00-.306-.025h-.717v1.342h.717c.106 0 .208-.008.306-.025a.683.683 0 00.26-.097.518.518 0 00.179-.204.757.757 0 00.067-.345.757.757 0 00-.067-.345.519.519 0 00-.18-.204zM1 8.467V15h14V8.467zm4.872 2.996a1.257 1.257 0 01-.253.46 1.254 1.254 0 01-.45.324 1.653 1.653 0 01-.67.122h-.971v1.605h-.924V9.497h1.894c.263 0 .487.04.67.122.185.082.335.19.451.323.116.134.2.286.253.458a1.797 1.797 0 010 1.063zm4.082 1.15a2.035 2.035 0 01-.356.716c-.16.2-.357.358-.594.473a1.903 1.903 0 01-.839.172H6.353V9.497h1.812c.27 0 .523.046.756.138.234.092.436.23.606.414.17.184.304.414.4.69.096.275.144.6.144.972 0 .326-.039.627-.117.903zm3.607-2.288h-2.03v1.034h1.759v.765h-1.76v1.85h-.923V9.497h2.954zm-4.678.401a.91.91 0 00-.374-.298 1.41 1.41 0 00-.573-.103h-.66v2.822H8.1c.134 0 .263-.023.389-.07a.85.85 0 00.335-.228c.098-.107.177-.246.235-.417.06-.172.089-.38.089-.627 0-.226-.02-.43-.062-.612a1.258 1.258 0 00-.203-.467z",
    fill: "#7d8898"
  }));
}

SvgDocPdf.clsName = 'icon-www__doc_pdf';
SvgDocPdf.remarkName = 'unknown';
export default SvgDocPdf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/DocPdf.js
// module id = 2334
// module chunks = 17 18